/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps, useMemo } from 'react';
import { getIconGradientColors } from './colorUtils';

type WorkColorableProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

const WorkColorable = ({ color, ...props }: WorkColorableProps) => {
  const gradientId = useMemo(
    () => `work_colorable_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const { primary, secondary } = getIconGradientColors('Work', color);

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="24" cy="24" r="24" fill={`url(#${gradientId})`} />
      <g transform="translate(9, 10) scale(0.73)" stroke="#F7F5F8" strokeWidth="1.64" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M8.11592 21.7483H5.94618C2.45666 21.7483 0.648828 18.5649 0.648828 14.5776V8.1599M40.5509 8.1124V14.5301C40.5509 18.5164 38.743 21.7482 35.2535 21.7482H33.063M30.6 19.1V6.54643M11.85 19.1V6.54643M14.35 21.7429H28.1M15.6 3.74379V2.73461C15.6 1.5557 16.5594 0.6 17.7429 0.6H24.1805C25.364 0.6 26.3234 1.5557 26.3234 2.73462V3.74379M2.74286 6.04121H38.4571C39.6406 6.04121 40.6 6.99691 40.6 8.17583V35.4654C40.6 36.6443 39.6406 37.6 38.4571 37.6H2.74286C1.55939 37.6 0.6 36.6443 0.6 35.4654V8.17583C0.6 6.99691 1.55939 6.04121 2.74286 6.04121ZM33.1 25.1281C33.1 25.448 32.8184 25.7071 32.4708 25.7071H28.7296C28.3808 25.7071 28.1 25.448 28.1 25.1281V19.6786C28.1 19.3595 28.3808 19.1 28.7296 19.1H32.4708C32.8184 19.1 33.1 19.3595 33.1 19.6786V25.1281ZM14.35 25.1281C14.35 25.448 14.0684 25.7071 13.7208 25.7071H9.97961C9.63082 25.7071 9.35 25.448 9.35 25.1281V19.6786C9.35 19.3595 9.63082 19.1 9.97961 19.1H13.7208C14.0684 19.1 14.35 19.3595 14.35 19.6786V25.1281Z" />
      </g>
      <defs>
        <linearGradient id={gradientId} x1="6.5" y1="3" x2="36.5" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WorkColorable;
